/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClientsForActor } from './ClientsForActor';
import {
    ClientsForActorFromJSON,
    ClientsForActorFromJSONTyped,
    ClientsForActorToJSON,
} from './ClientsForActor';

/**
 * Payload of enumerated client organizations for each actor
 * @export
 * @interface ClientsForActorsResponse
 */
export interface ClientsForActorsResponse {
    /**
     * 
     * @type {Array<ClientsForActor>}
     * @memberof ClientsForActorsResponse
     */
    items: Array<ClientsForActor>;
}

/**
 * Check if a given object implements the ClientsForActorsResponse interface.
 */
export function instanceOfClientsForActorsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

export function ClientsForActorsResponseFromJSON(json: any): ClientsForActorsResponse {
    return ClientsForActorsResponseFromJSONTyped(json, false);
}

export function ClientsForActorsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientsForActorsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ClientsForActorFromJSON)),
    };
}

export function ClientsForActorsResponseToJSON(value?: ClientsForActorsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(ClientsForActorToJSON)),
    };
}

